module.exports = __webpack_public_path__ + "img/dongji_ps_23.d0c7f1ac.jpg";